import { useEffect, useState } from "react"
import Modal from "."
import VerifyOtp from "../_Login/VerifyOtp"
import useService from "../../hooks/useService"
import { sendOtpForEmployeeValidation, verifyOtpForEmployeeValidation } from "../../services/Customer";

const EmployeeValidationModal = (props: { open: boolean, onClose: (success?: boolean) => any, dgCustomerRefNo: string, phone: string }) => {
    const { onClose, open, dgCustomerRefNo, phone } = props;
    const [validityTime, setValidityTime] = useState(30000);
    const [resendOtpReqCount, setResendOtpReqCount] = useState(1);
    const [isResendOtp, setIsResendOtp] = useState(false);
    const [mobileNumber, setMobileNumber] = useState('');
    const { execute } = useService();

    useEffect(() => {
        if (phone) {
            setMobileNumber(phone);
        }
    }, [phone]);
    
    const onValidityExpire = () => {
        setIsResendOtp(true);
        setValidityTime(resendOtpReqCount >= 3 ? 180000 : 30000);//set timer of 1 min upto 3 count else timer of 3 min
        setResendOtpReqCount(resendOtpReqCount + 1);//increment count on request of calling function
        if (resendOtpReqCount == 5) setIsResendOtp(false);
    }

    const sendOtp = async (phone: string) => {
        const result = await execute(() => sendOtpForEmployeeValidation({ dgCustomerRefNo }));
        if(!result.error && result.data?.status === 'ok') {
            setMobileNumber(result.data.otpSentTo);
        }
        return result;
    }

    const verifyOtp = async (phone: string, otp: string) => {
        const res = await execute(() => verifyOtpForEmployeeValidation({ otp, mobileNumber }));
        if (res.error === null && res.data?.otpMatched)
            onClose(true);
        return res
    }

    return (
        <div>
            <Modal onClose={onClose} disableBackdropClick={true} open={open} title="Verify OTP" >
                <VerifyOtp
                    isResendOtp={isResendOtp}
                    onValidityExpire={onValidityExpire}
                    phone={mobileNumber}
                    email={''}
                    setIsResendOtp={setIsResendOtp}
                    validityTime={validityTime}
                    verifyOTPService={verifyOtp}
                    sendOTPService={sendOtp}
                    showDefaultMsg={true}
                />
            </Modal>
        </div>
    )
}

export default EmployeeValidationModal
